/// <reference path="../../Common/Helpers/GridEditorBase.ts" />

namespace TabAurous.Finance {

    @Serenity.Decorators.registerClass()
    export class AccountingPeriodDetailsEditor extends _Ext.GridEditorBase<AccountingPeriodDetailsRow> {
        protected getColumnsKey() { return "Finance.AccountingPeriodDetails"; }
        protected getDialogType() { return AccountingPeriodDetailsDialog; }
        protected getLocalTextPrefix() { return AccountingPeriodDetailsRow.localTextPrefix; }
        
        
        constructor(container: JQuery) {
            super(container); 
        }

        protected getButtons() {
            let buttons = super.getButtons();
            buttons = buttons.filter(x => x.cssClass != "add-button"); 
            // *** Add Select Button to Grid Editor ***
            buttons.push({
                title: "Select Voucher",
                cssClass: "stock-button",
                hotkey: "alt+k",
                hint: 'alt+k',
                onClick: () => {
                    var companyid = (this.parentDialog as AccountingPeriodDialog).form.CompanyId.value;
                    if (companyid == null) {
                        Q.alert('Company is not selected');
                        return;
                    }
                   
                    var pickerDialog = new _Ext.GridItemPickerDialog({
                        gridType: OMS.VoucherSelectGrid, multiple: true, title: "Select Voucher",
                        preSelectedKeys: this.value.map(k => k.VoucherTypeId)
                        });
                    

                    pickerDialog.onSuccess = (selectedItems: any[]) => {
                        let selectedItems2 = selectedItems.filter(t => { return !Q.any(this.view.getItems(), n => n.VoucherTypeId == t.VoucherTypeId) });
                        var self = this;
                        var details = [];
                        
                        // #region Items to Grid
                        //for (let value of selectedItems2)
                        selectedItems2.forEach(function (value: OMS.VoucherMasterRow) {
                            
                            var item: AccountingPeriodDetailsRow = {
                                VoucherTypeId: value.VoucherTypeId,
                                CompanyId:  parseInt(companyid),
                                IsClosed: false,
                                VoucherTypeName: value.VoucherTypeName,
                                TypeOfVoucher: value.TypeOfVoucher

                            };

                            details.push(item);

                        }); 
                        for (let Detail of details) {
                            Detail[this.getIdProperty()] = "`" + this.nextId++; 
                            if (this.validateEntity(Detail, Detail.DetailsId)) {
                                this.view.addItem(Detail);
                            }
                        } 
                    }


                    pickerDialog.dialogOpen();
                }
            });

            return buttons;
        }
        validateEntity(row, id) {
            var sameProduct = Q.tryFirst(this.view.getItems(), x => x.VoucherTypeId === row.VoucherTypeId);
            if (sameProduct && this.id(sameProduct) !== id) {
                Q.alert('This Voucher already exists!');
                return false;
            }
            //row.LineTotal = (row.Quantity || 0) * (row.UnitPrice || 0) - (row.Discount || 0);
            return true;
        }

        

    }
}